<div class="header">
  <h3>
    Zip XML
  </h3>
</div>

<app-saletax-grouped-list></app-saletax-grouped-list>
<!-- <p-steps [model]="items" [(activeIndex)]="step" [readonly]="false" styleClass="steps-custom"></p-steps>

<div class="box-parent" *ngIf="step === 0">
  <app-saletax-ungrouped-list></app-saletax-ungrouped-list>
</div>

<div class="box-parent" *ngIf="step === 1">
  <app-saletax-grouped-list></app-saletax-grouped-list>
</div> -->



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/saletax.component.html